import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box, Text } from '@bridebook/ui';
import { RsvpQuestionFormValues } from '@bridebook/web/lib/rsvp/types';
import { useTranslation } from 'next-i18next';
import styles from '@bridebook/web/components/events/selector/event-selector.style';
import { CheckboxField } from '@bridebook/aura';

interface EventOption {
  value: string;
  label: string;
}

interface IProps {
  control: Control<RsvpQuestionFormValues>;
  eventOptions: EventOption[];
  handleSelectCheckbox: (value: string) => void;
  handleSelectAllCheckbox: () => void;
}

export const EventSelector: FC<IProps> = ({
  control,
  eventOptions,
  handleSelectCheckbox,
  handleSelectAllCheckbox,
}) => {
  const { t } = useTranslation('weddingWebsite');

  return (
    <Controller
      name="events"
      control={control}
      render={({ field }) => (
        <Box style={styles.listWrapper}>
          <CheckboxField
            label={<Text style={styles.label}>{t('rsvp.form.events.all.label')}</Text>}
            id="rsvp-select-all-checkbox"
            checked={field.value?.length === eventOptions.length}
            onCheckedChange={handleSelectAllCheckbox}
          />
          <Box style={styles.innerListWrapper}>
            {eventOptions.map((option) => (
              <CheckboxField
                key={option.value}
                id={option.value}
                label={<Text style={styles.label}>{option.label}</Text>}
                checked={field.value?.includes(option.value)}
                onCheckedChange={() => handleSelectCheckbox(option.value)}
              />
            ))}
          </Box>
        </Box>
      )}
    />
  );
};
